var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-spin',{attrs:{"tip":_vm.spinnerLoaderLabel,"size":"large","spinning":_vm.spinnerLoader}},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('usersDetail')],1)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }